<template>
  <el-dialog
    title="未上传成功信息"
    :visible="isUploadFailShow"
    width="500px"
    center
    :close-on-click-modal="false"
    @close="$emit('update:isUploadFailShow', false)"
  >
    <div class="fail-title">
      <i class="iconfont icon-tip"></i>以下工号或手机号已存在，请勿重复添加
    </div>
    <div class="fail-list">
      <div class="number-list">
        <div class="title">工号</div>
        <div class="list">
          <div
            v-show="uploadFail.number.length != 0"
            v-for="(item, index) in uploadFail.number"
            :key="index"
            class="number"
          >
            {{ item }}
          </div>
          <div class="empty" v-show="uploadFail.number.length == 0">无数据</div>
        </div>
      </div>
      <div class="number-list">
        <div class="title">手机号</div>
        <div class="list">
          <div
            v-show="uploadFail.phone.length != 0"
            v-for="(item, index) in uploadFail.phone"
            :key="index"
            class="phone"
          >
            {{ item }}
          </div>
          <div class="empty" v-show="uploadFail.phone.length == 0">无数据</div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="$emit('update:isUploadFailShow', false)"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    isUploadFailShow: {
      type: Boolean,
      default: false,
    },
    uploadFail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "./teacher-upload-fail-list.scss";
</style>